import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaQuoteLeft } from 'react-icons/fa';

export default ({ field_testimonial, ...rest }) => {
  const testimonial = (
    <Col xs="12" md="10" xl="8">
      <FaQuoteLeft
        size={20}
        color={'#752163'}
        style={{ marginBottom: '15px' }}
      />
      <div
        dangerouslySetInnerHTML={{
          __html: field_testimonial.processed,
        }}
      />
    </Col>
  );
  return (
    <section {...rest}>
      <Container>
        <Row className="justify-content-center">{testimonial}</Row>
      </Container>
    </section>
  );
};
